import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  title: {
    id: 'report.contacts.title',
    description: 'Title for reports additional info section',
    defaultMessage: 'Yhteystiedot',
  },
  map: {
    id: 'report.contacts.map',
    defaultMessage:
      'Karttaa ei saatavilla koska osoitetta ei ole annettu tai osoite on lukukelvoton.',
    description: 'Visible text when map cant be rendered',
  },
  visitingAddress: {
    id: 'report.contacts.visitingAddress',
    description: 'Label for visiting address',
    defaultMessage: 'Käyntiosoite:',
  },
  mailingAddress: {
    id: 'report.contacts.mailingAddress',
    description: 'Label for mailing address',
    defaultMessage: 'Postiosoite:',
  },
  atytj_label: {
    id: 'report.contacts.address.source.atytj.label',
    description: 'Label for YTJ address source',
    defaultMessage: 'YTJ',
  },
  local_label: {
    id: 'report.contacts.address.source.local.label',
    description: 'Label for local address source',
    defaultMessage: 'Itse määritetty',
  },
  notKnown: {
    id: 'report.contacts.notKnown',
    description: 'Some info is not known => user should call 0100100',
    defaultMessage: 'Ei tiedossa, soita ',
  },
  tel: {
    id: 'report.contacts.tel',
    description: 'Label for telephone number',
    defaultMessage: 'Matkapuhelinnumero:',
  },
  phone: {
    id: 'report.contacts.phone',
    description: 'Label for phone number',
    defaultMessage: 'Puhelin:',
  },
  fax: {
    id: 'report.contacts.fax',
    description: 'Label for fax number',
    defaultMessage: 'Faksi:',
  },
  email: {
    id: 'report.contacts.email',
    description: 'Label for email',
    defaultMessage: 'Sähköpostiosoite:',
  },
  website: {
    id: 'report.contacts.website',
    description: 'Label for company website',
    defaultMessage: 'Kotisivu:',
  },
  street_placeholder: {
    id: 'report.contacts.addressPlaceholder',
    description: 'Placeholder for address',
    defaultMessage: 'osoite',
  },
  street_na_placeholder: {
    id: 'report.contacts.addressNaPlaceholder',
    description: 'Placeholder for missing address',
    defaultMessage: 'osoite ei ole saatavilla',
  },
  zip_placeholder: {
    id: 'report.contacts.zipPlaceholder',
    description: 'Placeholder for zip code',
    defaultMessage: 'postinumero',
  },
  zip_na_placeholder: {
    id: 'report.contacts.zipNaPlaceholder',
    description: 'Placeholder for missing zip code',
    defaultMessage: 'postinumero ei ole saatavilla',
  },
  city_placeholder: {
    id: 'report.contacts.cityPlaceholder',
    description: 'Placeholder for city',
    defaultMessage: 'kaupunki',
  },
  city_na_placeholder: {
    id: 'report.contacts.cityNaPlaceholder',
    description: 'Placeholder for missing city',
    defaultMessage: 'kaupunki ei ole saatavilla',
  },
  contact0100100Other: {
    id: 'report.contact.contact0100100Other',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100OtherWeb: {
    id: 'report.contact.contact0100100OtherWeb',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100OtherPhone: {
    id: 'report.contact.contact0100100OtherPhone',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100Missing: {
    id: 'report.contact.contact0100100Missing',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100MissingWeb: {
    id: 'report.contact.contact0100100MissingWeb',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100MissingPhone: {
    id: 'report.contact.contact0100100MissingPhone',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100WebLabel: {
    id: 'report.contact.contact0100100WebLabel',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },
  contact0100100PhoneLabel: {
    id: 'report.contact.contact0100100PhoneLabel',
    description: 'Search for other information from 0100100',
    defaultMessage: '0100100 provides contact information',
  },

  // OTHERS
  showMapBtn: {
    id: 'report.contacts.showMapBtn',
    defaultMessage: 'Näytä kartta',
    description: 'Show map button text',
  },
});
